import {
  IsBoolean,
  IsDateString,
  IsIn,
  IsInt,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Min,
} from 'class-validator';
import { FIELD_VALUE_SOURCES, type FieldValueSource } from '../../label/field-value-source';
import { DEFROST_DECLARATIONS, type DefrostDeclaration } from './defrost-declaration.enum';
import { PREPARATION_KINDS, type PreparationKind } from './preparation-kind.enum';
import { STORAGE_CONDITIONS, type StorageCondition } from './storage-condition.enum';

export class CounterLabelDataResponseDto {
  @IsUUID()
  id!: string;

  @IsOptional()
  @IsUUID()
  recipeId?: string | null;

  @IsOptional()
  @IsUUID()
  ingredientId?: string | null;

  @IsOptional()
  @IsString()
  legalName?: string | null;

  @IsOptional()
  @IsIn(FIELD_VALUE_SOURCES)
  legalNameSource?: FieldValueSource | null;

  @IsOptional()
  @IsIn(STORAGE_CONDITIONS)
  storageCondition?: StorageCondition | null;

  @IsOptional()
  @IsIn(FIELD_VALUE_SOURCES)
  storageConditionSource?: FieldValueSource | null;

  @IsOptional()
  @IsNumber()
  storageTemperatureMinC?: number | null;

  @IsOptional()
  @IsNumber()
  storageTemperatureMaxC?: number | null;

  @IsOptional()
  @IsString()
  storageNote?: string | null;

  @IsBoolean()
  isPerishable!: boolean;

  @IsBoolean()
  isFreshPasta!: boolean;

  @IsOptional()
  @IsDateString()
  expiryDate?: string | null;

  @IsBoolean()
  isBeverage!: boolean;

  @IsOptional()
  @IsNumber()
  alcoholByVolume?: number | null;

  @IsBoolean()
  isGlazedFrozen!: boolean;

  @IsOptional()
  @IsNumber()
  glazePercent?: number | null;

  @IsBoolean()
  printExpiryOptIn!: boolean;

  @IsIn(PREPARATION_KINDS)
  preparationKind!: PreparationKind;

  @IsIn(DEFROST_DECLARATIONS)
  defrostDeclaration!: DefrostDeclaration;

  @IsOptional()
  @IsString()
  defrostExceptionNote?: string | null;

  @IsInt()
  @Min(1)
  labelDataVersion!: number;

  /**
   * Calculated field — never a stored column. Mirrors
   * `ResolveDefrostStateResult.needsVerification` (backend
   * `recipe/service/defrost-state.ts`): true when the persisted pair is not
   * a fresh, certain derivation from the production process — a pre-existing
   * legacy badge, a legacy manual override, or an unconfirmed gray zone.
   * Feeds the persistent "verifica questa dicitura" warning and the
   * self-emptying work list on the menu item (plan.md "Decongelato,
   * prevenzione").
   */
  @IsBoolean()
  needsVerification!: boolean;

  /**
   * Calculated field — never a stored column. Mirrors
   * `ResolveDefrostStateResult.requiresConfirmation`: true when the
   * ASSEMBLED_RAW + defrosted gray zone is still waiting for the operator's
   * explicit `confirmDefrostGrayZone` answer.
   */
  @IsBoolean()
  requiresConfirmation!: boolean;
}
